import { render, staticRenderFns } from "./tabSelect.vue?vue&type=template&id=ffb91626&scoped=true&"
import script from "./tabSelect.vue?vue&type=script&lang=ts&"
export * from "./tabSelect.vue?vue&type=script&lang=ts&"
import style0 from "./tabSelect.vue?vue&type=style&index=0&id=ffb91626&lang=scss&scoped=true&"
import style1 from "./tabSelect.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffb91626",
  null
  
)

export default component.exports